import { request } from '@/shared/api/request'

export const getProject = ({params}) => {
	return request({ url: 'staff/get/project', method: 'GET', params: params })
}
